export const SUGGEST_SKILL_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS = {
	hasDismissedWritePrd: 'suggest-skill-based-on-page-title:hasDismissedWritePrd',
	hasDismissedWriteHowToArticle: 'suggest-skill-based-on-page-title:hasDismissedWriteHowToArticle',
	hasDismissedResearchInsights: 'suggest-skill-based-on-page-title:hasDismissedResearchInsights',
	hasDismissedCreateActionPlan: 'suggest-skill-based-on-page-title:hasDismissedCreateActionPlan',
	hasDismissedMarketingBriefSkill:
		'suggest-skill-based-on-page-title:hasDismissedMarketingBriefSkill',
	hasDismissedAllSkillSuggestions:
		'suggest-skill-based-on-page-title:hasDismissedAllSkillSuggestions',
} as const;

export const SuggestSkillBasedOnPageTitleOnboardingKeys: readonly (
	| 'suggest-skill-based-on-page-title:hasDismissedWritePrd'
	| 'suggest-skill-based-on-page-title:hasDismissedWriteHowToArticle'
	| 'suggest-skill-based-on-page-title:hasDismissedResearchInsights'
	| 'suggest-skill-based-on-page-title:hasDismissedCreateActionPlan'
	| 'suggest-skill-based-on-page-title:hasDismissedMarketingBriefSkill'
	| 'suggest-skill-based-on-page-title:hasDismissedAllSkillSuggestions'
)[] = Object.values(SUGGEST_SKILL_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS);
